
// Vue
import router from "@/app/routes/router";
import store from "@/app/stores/store";

// Date-Fns helpers
import { isAfter, parseISO, formatISO } from 'date-fns';

// set page title based on route meta title
export default function routeGuard() {
	router.beforeEach((to, from, next) => {
		const userToken = store.getters.getUserToken;
		const userAuthenticated = store.getters.getUserAuthentication;
		const authExpiry = store.getters.getAuthExpiry;
		const requiredAuth = to.meta.isAuthRequired;
		const requiredPassword = to.meta.isPasswordRequired;
		const globalRoute = to.meta.isGloballyAccessible;
		const referrerRoute = to.fullPath ? to.fullPath : '/';

		let metaTitle = '';

		if (globalRoute) {
			next(true);
		} else {
			// Check if destination route required Password
			if (requiredPassword) {
				// Redirect to auth password when auth password is expired
				let authExpired = false;
				if (authExpiry) {
					const dateToday = formatISO(new Date());
					authExpired = isAfter(parseISO(dateToday), parseISO(authExpiry));
				}

				// Check if user already validated
				// if (userAuthenticated && !authExpired) {
				// 	metaTitle = to.meta.title;
				// 	next(true);
				// } else {
				// 	store.dispatch('unauthenticate');
				// 	metaTitle = 'Love My Dog Club | Admin - Authenticate';
				// 	next({name: 'Auth Password'});
				// }
			} else {
				if (userAuthenticated) {
					metaTitle = 'Love My Dog Club | Admin - Login';
					next({name: 'Auth Login'});
				} else {
					metaTitle = to.meta.title;
					next(true);
				}
			}
			
			// Check if destination route required Authentication
			if (requiredAuth) {
				// Check if Token exists
				if (userToken) {
					metaTitle = to.meta.title;
					next(true);
				} else {
					// Redirect to Login if token Doesn't exist
					metaTitle = 'Love My Dog Club | Admin - Login';
					next({name: 'Auth Login', query: { from: referrerRoute }});
				}
			} else {
				// If user is logged in, redirect back to authenticated pages. Prevents going back to Login and Registration.
				if (userToken) {
					metaTitle = 'Love My Dog Club | Admin - Users';
					next({name: 'Users'});
				} else {
					metaTitle = to.meta.title;
					next(true);
				}
			}

			// Set tab title
			document.title = metaTitle;
		}
	});
}